function buildInitialWritePayload(caseId, personId, existingAttachmentData) {
  const payload = {
    id: caseId,
    PERSON_ID: personId,

    // Map the read model to the simpler write model. Exclude things with a null AID to make
    // sure we strip out the null "template" record if it exists
    ATTACHMENTS: {
      ATTACHMENTS: existingAttachmentData
        .filter((x) => x.AID.VALUE)
        .map((x) => {
          const flattened = {};

          for (const [key, valueObj] of Object.entries(x)) {
            flattened[key] = valueObj.VALUE;
          }

          return flattened;
        }),
    },
  };

  return payload;
}

function createWritePayloadEntry(aid, filename, today) {
  const createDate = today.toISOString().slice(0, 10).replace(/-/g, "");

  return {
    FILE_NAME: filename,
    CREATE_DATE: createDate,
    NAME: filename,
    AID: aid,
  };
}

function updateReadModel(existingReadModel, allWriteObjects) {
  const arrOrig = existingReadModel.ATTACHMENTS.FIELDS.ATTACHMENTS;
  const templateEntry = arrOrig[0];
  const arrFinal = [];

  // Empty write array (deleted last attachment) = use an empty object. We do not want to let
  // the read model go to zero since we rely on it for future UI updates (like on upload).
  if (!allWriteObjects.length) {
    allWriteObjects.push({});
  }

  // Map the simple write model to the more complex read model
  for (const writeObj of allWriteObjects) {
    const inReadFormat = {};

    for (const key in templateEntry) {
      const templateField = templateEntry[key];

      if (templateField) {
        inReadFormat[key] = {
          ...templateField,
          VALUE: writeObj[key] ?? null,
        };
      }
    }

    arrFinal.push(inReadFormat);
  }

  existingReadModel.ATTACHMENTS.FIELDS.ATTACHMENTS = arrFinal;
}

export { buildInitialWritePayload, createWritePayloadEntry, updateReadModel };
